import {
  BASE_URL,
  APP_BRAND_NAME,
  APP_EVENT_ID,
  REAL_SCREEN,
} from "../utils/consts";

export const getPersonalConferanceURL = (wherebyURL) => {
  var roomId = wherebyURL.split("/").pop().split("?")[0];
  let meetingURL =
    APP_BRAND_NAME === REAL_SCREEN
      ? `${BASE_URL}/Xchange/Meeting/?roomId=${roomId}`
      : `${BASE_URL}/xchange/${APP_EVENT_ID}/Meeting/?roomId=${roomId}`;
  return meetingURL;
};

export const getNextMeetingRelativeURL = (xchangeMeetingURL) => {  
  var parser = document.createElement('a');
  parser.href = xchangeMeetingURL; 
  return parser.pathname.substr(1);
};
